// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum Service {
  Auto = 0,
  Norm = 1,
  Run = 2,
  Oos = 3,
  Ins = 4,
  InsCons = 5,
  CtIns = 6,
  CtInsCons = 7,
  CpIns = 8,
  CpInsCons = 9,
  HaIns = 10,
  HaInsCons = 11,
  MrIns = 12,
  MrInsCons = 13,
  MOS = 14,
  Ind = 15,
  Test = 16,
  TestSwitch = 17,
  FireMain = 18,
  FireAlt = 19,
  FirePhase1 = 20,
  FirePhase2 = 21,
  HospitalPhase1 = 22,
  HospitalPhase2 = 23,
  Shuttle = 24,
  Sabbath = 25,
  Construction = 26,
  Earthquake = 27,
  L = 28,
  Attendant = 29,
  CodeBlue = 30,
  Homing = 31,
  ResetGoingUp = 32,
  ResetGoingDown = 33,
  Stalled = 34,
  CarToLobby = 35,
  LoadBypass = 36,
  LoadWeighingOverload = 37,
  MedicalEmergency = 38,
  CalibrateLoadWeigher = 39,
  CarSwitchElevatorOff = 40,
  HallSwitchElevatorOff = 41,
  LowPressure = 42,
  HospitalServiceOperation = 43,
  VIP = 44,
  SecurityRecall = 45,
  TugServiceOperation = 46,
  HotOilOperation = 47,
  RiotControl = 48,
  CarSwitchElevatorOff2 = 49,
  Heliport = 50,
  Cfss0_Phase1 = 51,
  Cfss0_Transition = 52,
  Cfss0_Phase2 = 53,
  EMS_Phase1 = 54,
  Unknown = 55,
  NAV = 56,
  EmergencyMedicalTec = 57,
  EPC = 58,
  CorrectionRun = 59,
  EmergencyPowerReturn = 60,
  EmergencyPowerWait = 61,
  EmergencyPower = 62,
  OverloadedCar = 63,
  DoorTimeClose = 64,
  DoorTimeOpen = 65,
  CancelHallCalls = 66,
  LoadNonStop = 67,
  ModerateIncomingTraffic = 68,
  DoorCloseProtection = 69,
  AntiNusianceOperation = 70,
  ARD = 71,
  Parked = 72,
  Idle = 73,
  ParkingSwitch = 74,
  GCB = 75,
  Initializing = 76,
  EmergencyStopButton = 77,
  ACP = 78,
  WildCarOperation = 79,
  DriveBrakeFailure = 80,
  EFP = 81,
  CRL = 82,
  ConcealedRiserOperation = 83,
  CarEmergency = 84,
  DoorOpenSwitch = 85,
  WildCarService = 86,
  REC = 87,
  OHT = 88,
  ARE = 89,
  EPD = 90,
  JudgeCar = 91,
  EmergencyRecall = 92,
  Priority = 93,
  FirePreAlarm = 94,
  Night = 95,
  Building = 96,
  Special = 97,
  ServiceProtection = 98,
  StopSwitch = 99,
  DispatchLoss = 100,
  LobbyIndepedent = 101,
  DoorDisconnect = 102,
  RearDoorDisconnect = 103,
  ControlledShutdown = 104,
  DriveFault = 105,
  Initialization = 106,
  PowerLoss = 107,
  DriveOff = 108,
  Safeties = 109,
  Reset = 110,
  ShuntTrip = 111,
  LowOil = 112,
  Access = 113,
  NegativePressure = 114,
  AuxillaryPowerLanding = 115,
  Dead = 116,
  CriticalFail = 117,
  DownwardStall = 118,
  UpWardStall = 119,
  Disabled = 120,
  TestDisplay = 121,
  CloseFailure = 122,
  NoStarter = 123,
  StuckStarter = 124,
  CarCaptureSecurity = 125,
  Capture = 126,
  Security = 127,
  ViscosityCondition = 128,
  MedicalEmergencyPhase1 = 129,
  MedicalEmergencyPhase2 = 130,
  TelescopicResynchronizationInProgress = 131,
  TelescopicResynchronizationRecall = 132,
  ServiceDrive = 133,
  Freight = 134,
  PriorityLandingHigh = 135,
  PriorityLandingLow = 136,
  Simplex = 137,
  AutoReturnDrive = 138,
  LandingCallDisconnect = 139,
  PowerOk = 140,
  Started = 141,
  Stopping = 142,
  BrakeBurnishing = 143,
  Acceleration = 144,
  Deceleration = 145,
  Ready = 146,
  Continous = 147,
  CLS = 148,
  Stopped = 149,
  NormEnabled = 150,
  CounterWeightDerailment = 151,
  HomingAndShutdown = 152,
  HiWind = 153,
  Storm = 154,
  Reduced = 155,
  CCP1 = 156,
  CarCln = 157,
  OOSP1 = 158,
  Inv = 159,
  Prc = 160,
  HatchAccess = 161,
  CarHospital = 162,
  HallShutdownSwitch = 163,
  NoCommunication = 164,
  InitFailiure = 165,
  AutomaticShutdown = 166,
  StartProtect = 167,
  OverspeedFault = 168,
  BrakeFault = 169,
  MotionFault = 170,
  DoorZoneFault = 171,
  HallIndependentService = 172,
  CommunicationLossToGroup = 173,
  CarInGroupService = 174,
  DoorHoldActive = 175,
  MassMedInCar = 176,
  RunMonitorFailure = 177,
  FrontHoistDoorWatch = 178,
  SelectorFault = 179,
  RearHoistDoorWatchdog = 180,
  FrontCarDoorWatchdog = 181,
  RearCarDoorWatchdog = 182,
  FrontDoorNudging = 183,
  RearDoorNudging = 184,
  DiagnosticsCarLockout = 185,
  InitializationShutdown = 186,
  LoadweigherShutdown = 187,
  CheckedRedundancy = 188,
  CarCycling = 189,
  TelescopingJackResync = 190,
  InconspicuousRiser = 191,
  RetiringCamFailure = 192,
  NextUp = 193,
  TransferFloor = 194,
  FrontDoorHold = 195,
  RearDoorHold = 196,
  FrontDoorCommunicationLoss = 197,
  RearDoorCommunicationLoss = 198,
  ExternalControlOfCall = 199,
  ExternalControlOfFrontDoor = 200,
  ExternalControlOfRearDoor = 201,
  ExternalSecurity = 202,
  EmergencyDispatch = 203,
  NeoNatalService = 204,
  LobbyStop = 205,
  UnintendedMotion = 206,
  RescueOperation = 207,
  LoadWeighingByPass = 208,
  Earthquake2 = 209,
  SafetyStringOpen = 210,
  Cfss1_Phase1 = 211,
  Cfss1_Phase2 = 212,
  LobbyShutdownSwitch = 213,
  Normal = 214,
  HallButtonFailure = 215,
  EncoderResynchronization = 216,
  EmergencyPowerShutdown = 217,
  FireAlt2 = 218,
  EmergencyPowerSelected = 219,
  KeyOutOfService = 220,
  OverweightStop = 221,
  EmergencyHospitalRecall = 222,
  EmergencyHospitalInCar = 223,
  ActiveShooter = 224,
  MarshalService = 225,
  Wanderguard = 226,
  BatteryRescue = 227,
  EPCarRecallFailed = 228,
  EPCarRecalledOK = 229,
  HallRecallOperation = 230,
  TUGAGVService = 231,
  AuxSelectionRelay = 232,
  CBP = 233,
  CDO = 234,
  CHN = 235,
  CandalOperation = 236,
  CarEmergencyService2 = 237,
  CardReaderOperation = 238,
  CutoffHallCall = 239,
  DelayedCarProtection = 240,
  DisabledDoorOperation = 241,
  DoorHoldButton = 242,
  DoorLockFailure = 243,
  DoorTimeProtectionClosed = 244,
  DoorTimeProtectionOpen = 245,
  DriveBreakFault = 246,
  ElectricalRecall = 247,
  EmergencyFiremansService = 248,
  EmergencyHospitalService = 249,
  EmergencyPowerRescue = 250,
  EmergencyPowerTransfer = 251,
  FireServiceShutdown = 252,
  GalMomMohDoorOperation = 253,
  HallButtonProtection = 254,
  InService = 255,
  InServiceParked = 256,
  IndependentServiceShutdown = 257,
  Initialize = 258,
  MTO = 259,
  NotAvailableFaulted = 260,
  OverloadDevice = 261,
  ParkingShutdown = 262,
  RiotOperation = 263,
  SeismicOperation = 264,
  SeparateRiserOperatation = 265,
  WCS = 266,
  EMK = 267,
  Gap = 268,
  InServiceNoDemand = 269,
  PFO = 270,
  VandalOperation = 271,
  _50 = 272,
  _51 = 273,
  _52 = 274,
  _53 = 275,
  _54 = 276,
  _55 = 277,
  _56 = 278,
  _57 = 279,
  _58 = 280,
  _59 = 281,
  _60 = 282,
  _61 = 283,
  _62 = 284,
  _63 = 285,
  _64 = 286,
  _65 = 287,
  _66 = 288,
  _67 = 289,
  _68 = 290,
  _69 = 291,
  _70 = 292,
  _71 = 293,
  _72 = 294,
  _73 = 295,
  _74 = 296,
  _75 = 297,
  _76 = 298,
  _77 = 299,
  _78 = 300,
  _79 = 301,
  _80 = 302,
  _81 = 303,
  _82 = 304,
  _83 = 305,
  _84 = 306,
  _85 = 307,
  _86 = 308,
  _87 = 309,
  _88 = 310,
  _89 = 311,
  _90 = 312,
  _91 = 313,
  _92 = 314,
  _93 = 315,
  _94 = 316,
  _95 = 317,
  _96 = 318,
  _97 = 319,
  _98 = 320,
  _99 = 321,
  _100 = 322,
  _101 = 323,
  _102 = 324,
  _103 = 325,
  _104 = 326,
  _105 = 327,
  _106 = 328,
  _107 = 329,
  _108 = 330,
  _109 = 331,
  _110 = 332,
  _111 = 333,
  _112 = 334,
  _113 = 335,
  _114 = 336,
  _115 = 337,
  _116 = 338,
  _117 = 339,
  _118 = 340,
  _119 = 341,
  _120 = 342,
  _121 = 343,
  _122 = 344,
  _123 = 345,
  _124 = 346,
  _125 = 347,
  ContinuousOperation = 348,
  DirChangeOperation = 349,
  EngineerOnSite = 350,
  AntiBurglarControl = 351,
  BankerTrip = 352,
  BlockCarEmergencyPower = 353,
  EmergencyTrip = 354,
  EmergencyTripMedical = 355,
  FatalError = 356,
  GeneralError = 357,
  GuestControl = 358,
  InvalidDriveConfiguration = 359,
  InvalidHoistwayImage = 360,
  KeyBypass = 361,
  LockCarCall = 362,
  LockFloorCall = 363,
  MoveAround = 364,
  PassengerRelease = 365,
  ReserveDispatch = 366,
  RunPermission = 367,
  Warning = 368,
  ANS = 369,
  CES = 370,
  CRO = 371,
  DLF = 372,
  DOS = 373,
  DDO = 374,
  EPO = 375,
  EPT = 376,
  ERO = 377,
  IDL = 378,
  INI = 379,
  NOR = 380,
  PRK = 381,
  SCO = 382,
  SCX = 383,
  AlternateFire = 384,
  MainFire = 385,
  MaHospitalService = 386,
  PublicOperation = 387,
  Maintenance = 388,
  JailMaster = 389,
  JailSecure = 390,
  MachineRoomOverTemperature = 391,
  AlarmButtonPressed = 392,
  InternalCommunicationProblem = 393,
  PowerSwitchOn = 394,
  FloorTeachIn = 395,
  PowerSwitchLamp = 396,
  VipTripBestElevator = 397,
  BankerTripSwitch1 = 398,
  FloorOnFire = 399,
  FloorLightControl = 400,
  SafetyLightBarrierDoorOpen = 401,
  EmergencyPowerFeeder2Operation = 402,
  EmergencyPowerFeeder1Operation = 403,
  FireRecallFloorSelection = 404,
  EmergencyPowerCarLight = 405,
  CarLampOff = 406,
  EmergencyPowerFeeder1Lamp = 407,
  EmergencyMedicalLamp = 408,
  FireSwitchOffLampRegulation16 = 409,
  FireSwitchOffLampRegulation2 = 410,
  FireSwitchOffLamp = 411,
  FireEmergencyLamp = 412,
  FireEmergencyBuzzer = 413,
  AramidRopeMonitoring = 414,
  EmergencyTripBuzzer = 415,
  EarthquakeLamp = 416,
  EmergencyMedicalBuzzer = 417,
  EmergencyPowerFeeder2Lamp = 418,
  SkipStopOperation = 419,
  RopeStretchMonitoring = 420,
  BlockOperationIndicator = 421,
  ElevatorControlError = 422,
  LoadMeasurementError = 423,
  DoorControlError = 424,
  VipTripMiconic10 = 425,
  IndependentServiceMiconic10 = 426,
  IndependentServiceSecondary = 427,
  Cfss1_Transition = 428,
  InServiceGoingUp = 429,
  InServiceGoingDown = 430,
  MedicalEmergency2Phase1 = 431,
  MedicalEmergency2Phase2 = 432,
  CommunicationUndefined = 433,
  FireEmergency = 434,
  StatusNotAvailable = 435,
  EmergencyTripBestElevator = 436,
  EarthquakeAuxiliary = 437,
  BlockCarEmergencyPowerFeeder2 = 438,
  HydroPressureSwitch = 439,
  AcceptanceTestControl = 440,
  TechnicalOff = 441,
  CleanerControlMiconic10 = 442,
  FireAlarm = 443,
  FloodService = 444,
}
